import template from './simpleinput.html'
import Base from '../../core/base'
import Input from './base'
export default {
  name: 'simpleinput',
  init: Base.createViewModel(Input),
  template
}



// WEBPACK FOOTER //
// ./src/components/input/simpleinput.js